import { takeLeading, select } from 'redux-saga/effects';
import { callApi } from 'helpers/saga-helpers';
import { get } from 'lodash';
import { setStatsClaims } from 'containers/HomePage/actions';
import { REQUEST_STATS_CLAIMS } from 'containers/HomePage/constants';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import userToken from 'containers/services/security/access-token-storage';
import currentUserStorage from 'containers/services/security/current-user-storage';

export function* statsClaims(action: {
  count: any;
  type: string;
}): Generator<unknown> {
  const path = '/corporeal/common/claims-stats';
  const token = get(userToken.get(), 'token')
    ? get(userToken.get(), 'token')
    : yield select(makeSelectKeycloakToken());
  if (!token) return;
  const options = {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`,
      name: get(userToken.get(), 'token')
        ? get(currentUserStorage.get(), 'username')
        : null,
    },
    body: JSON.stringify({
      ...action.count,
      isLawyer: get(userToken.get(), 'token') ? false : true,
    }),
  };
  yield callApi(path, {}, options, [], setStatsClaims);
}

export function* requestStatsClaims() {
  yield takeLeading(REQUEST_STATS_CLAIMS, statsClaims);
}

export default [requestStatsClaims];
